import { render, staticRenderFns } from "./DownloadFileButton.vue?vue&type=template&id=b561ac42"
import script from "./DownloadFileButton.vue?vue&type=script&lang=js"
export * from "./DownloadFileButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports